import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { PropertiesService } from '@core/services/properties.service';
import { CustomEventService } from '@shared/services/custom-event.service';

import ActionTypesEnum from '@shared/enums/action-constant.enum';
import { MenuTypeEnum } from '@shared/enums/sign-up-type.enum';
import { UntilDestroy } from '@ngneat/until-destroy';
import { UserService } from '@core/services/user.service';
import { SidebarMenuEnum } from '@shared/enums/sidebar-menu.enum';
import { ActivatedRoute, NavigationEnd, Router, RouterState } from '@angular/router';
import { Subscription } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'layout-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit, OnDestroy {

  @Input() isCollapsed: boolean;
  @Input() menuStyle: any;
  @Input() menuStyleLoading: any;
  @Input() activeUser: ActiveUser.ActiveUserModel;
  @Input() showAbleMenus: any;
  isOpenTeam = false;
  showDashboard: boolean;
  showBugReport: boolean;
  showExecutiveDashboard: boolean;
  showGamificication: boolean;
  showGamificicationV2: boolean;
  showTeamHealth: boolean;
  showGitwiser: boolean;
  showQwiser: boolean;
  showAgileSpace: boolean;
  showProfile: boolean;
  showDataSource: boolean;
  showAdministration: boolean;
  showIntegration: boolean;
  developerId: any;

  openMap: { [name: string]: boolean } = {
    sub1: true,
    sub2: true,
    sub3: false,
    sub31: false,
    sub4: false
  };

  HamburgerMenu = MenuTypeEnum.HAMBURGER;
  CollapseMenu = MenuTypeEnum.COLLAPSE;
  private routerSubscription: Subscription;

  constructor(
    private activateRoute: ActivatedRoute,
    private router: Router,
    private customEventService: CustomEventService,
    private userService: UserService,
    public propertiesService: PropertiesService) {

  }


  ngOnInit() {
    this.showDashboard = this.showAbleMenus.find(menu => menu.key === SidebarMenuEnum.DASHBOARD)?.value ;
    // this.showBugReport = this.showAbleMenus.find(menu => menu.key === SidebarMenuEnum.BUG_REPORT).value;
    this.showGamificication = this.showAbleMenus.find(menu => menu.key === SidebarMenuEnum.GAMIFICATION)?.value  ;
    this.showGamificicationV2 = this.showAbleMenus.find(menu => menu.key === SidebarMenuEnum.GAMIFICATION_V2)?.value  ;
    this.showTeamHealth = this.showAbleMenus.find(menu => menu.key === SidebarMenuEnum.TEAM_HEALTH)?.value;
    this.showGitwiser = this.showAbleMenus.find(menu => menu.key === SidebarMenuEnum.GITWISER)?.value;
    this.showQwiser = this.showAbleMenus.find(menu => menu.key === SidebarMenuEnum.QWISER)?.value;
    this.showAgileSpace = this.showAbleMenus.find(menu => menu.key === SidebarMenuEnum.AGILESPACE)?.value;
    this.showExecutiveDashboard = this.showAbleMenus.find(menu => menu.key === SidebarMenuEnum.EXECUTIVE_DASHBOARD)?.value;
    this.showProfile = this.showAbleMenus.find(menu => menu.key === SidebarMenuEnum.PROFILE)?.value;
    this.showDataSource = this.showAbleMenus.find(menu => menu.key === SidebarMenuEnum.DATASOURCES)?.value;
    this.showIntegration = this.showAbleMenus.find(menu => menu.key === SidebarMenuEnum.INTEGRATIONS)?.value;
    this.showAdministration = this.showAbleMenus.find(menu => menu.key === SidebarMenuEnum.ADMINISTRATION)?.value;

    this.developerId = this.userService.activeUser.developerId;

    this.openMap = {
      sub1: false,
      sub2: false,
      sub3: false,
      sub4: this.router.url.indexOf('/gamification')!==-1,
    };

  // Router olaylarını dinle
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // this.openMap = {
        //   sub1: false,
        //   sub2: false,
        //   sub3: false,
        //   sub4: this.router.url.indexOf('/gamification')!==-1,
        // };
      }
    });
  }

  logOut(): void {
    this.customEventService.announceEvent(ActionTypesEnum.LOG_OUT);
  }

  openHandlerTeams(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  collapsedChange(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CHANGE_COLLAPSE);
  }


  ngOnDestroy() {

  }
}
